import { useTranslation } from 'react-i18next'
import { DuplicateIcon } from '@dhl-ui/icons'
import { IconButton, Tooltip } from '@dhl-ui/components'
import { useClipboard, useNotificationMessage } from '~/common'

type Props = {
  payload: string
  size?: number
}
export const ClipboardCopy = ({ payload, size = 16 }: Props) => {
  const [hasClipboard, copyToClipboard] = useClipboard()
  const { showSuccess } = useNotificationMessage()
  const { t } = useTranslation()
  return hasClipboard ? (
    <>
      <Tooltip title={t('admin.clipboard.tooltip')}>
        <IconButton
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            copyToClipboard(payload).then(() => {
              showSuccess(t('admin.clipboard.copiedToClipboard'))
            })
            return false
          }}
          aria-label="copy"
        >
          <DuplicateIcon sx={{ fontSize: size }} />
        </IconButton>
      </Tooltip>
    </>
  ) : null
}
